import useDrawerStack from 'Hooks/useDrawerStack';
import AISuggestionsDrawerItem from './AISuggestionsDrawerItem';
import { DRAWER_STACK } from 'Utils/constants';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';

function getHighlightFields(obj) {
    return Object.keys(obj).reduce((acc, key) => {
        const value = obj[key];
        if (typeof value === 'string' && value.trim() !== '') {
            acc.push(key);
        } else if (Array.isArray(value) && value.length > 0) {
            acc.push(key);
        }

        return acc;
    }, []);
}

export default function AISuggestionsDrawerContactDetected(props) {
    const { className, contact, onAccept, onReject } = props;

    const { open } = useDrawerStack();
    const { t } = useTranslation('contacts');
    const queryClient = useQueryClient();

    const handleSubmit = async (savedContact) => {
        await queryClient.invalidateQueries({ queryKey: ['invoices'] });
        onAccept(savedContact);
    };

    const handleClick = () => {
        const highlightFields = getHighlightFields(contact);

        open(DRAWER_STACK.CONTACT_EDITOR, {
            title: t('create-contact'),
            onCancel: onReject,
            onSubmit: handleSubmit,
            highlightFields,
            contact,
            submitButtonText: t('create-contact'),
            cancelButtonText: t('reject-suggestion'),
        });
    };

    return (
        <AISuggestionsDrawerItem
            image={
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
                    <circle cx="24" cy="24" r="21" fill="#6050C6"></circle>
                    <path
                        stroke="#fff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M28.09 31.727v-1.636a3.273 3.273 0 0 0-3.272-3.273h-6.545A3.273 3.273 0 0 0 15 30.091v1.636M21.545 23.546a3.273 3.273 0 1 0 0-6.546 3.273 3.273 0 0 0 0 6.546M33 31.727v-1.636a3.27 3.27 0 0 0-2.455-3.167M27.273 17.106a3.273 3.273 0 0 1 0 6.341"
                    ></path>
                </svg>
            }
            className={className}
            onClick={handleClick}
            label={t('new-contact-detected')}
            title={contact.name ?? ''}
            onClose={onReject}
        />
    );
}

AISuggestionsDrawerContactDetected.propTypes = {
    className: PropTypes.string,
    contact: PropTypes.object.isRequired,
    onAccept: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
};
